import { pubSub } from "../ably";
import { CHANNELS } from "../channel/channels.js";

// sessionId is accepted for call-site symmetry but history is read from the
// session-scoped provider channel, not per-id arguments.
export async function fetchPresentationState(_sessionId) {
  try {
    const history = await pubSub.getChannelHistory(CHANNELS.POLL, { limit: 1, maxPages: 1 });
    if (!history || !history.length) return null;
    const latest = history[0];
    const item = Array.isArray(latest?.data) ? latest.data[0] : null;
    if (!item || item.category !== "interactive") return null;
    let currentQuestionId = null;
    let slide = 0;
    if (item.isApproved === true && item.data) {
      const keys = Object.keys(item.data).filter((k) => /^question\d+$/i.test(k)).sort((a,b)=>parseInt(a.replace(/\D/g,""),10)-parseInt(b.replace(/\D/g,""),10));
      for (let i = keys.length - 1; i >= 0; i--) {
        const q = item.data[keys[i]];
        if (q?.isQuestionApproved === true && typeof q.questionID === "string") {
          currentQuestionId = q.questionID;
          slide = i + 1;
          break;
        }
        if (q?.isQuestionApproved === true) {
          currentQuestionId = q.questionID || `${item.id}_${keys[i]}`;
          slide = i + 1;
          break;
        }
      }
      if (!currentQuestionId && item.isApproved === true) slide = 0;
    }
    return {
      id: item.id,
      isApproved: item.isApproved === true,
      showresult: item.showresult === true,
      intropage: item.intropage === true,
      currentQuestionId,
      slide,
      data: item.data,
      poll: item,
    };
  } catch {
    return null;
  }
}

// opts.showresult only matters on the result slide (past the last question):
// false = users see the leaderboard skeleton, true = users see the published result.
export function updatePresentationState(sessionId, poll, slideIdx, opts = {}) {
  if (!poll || !sessionId) return;
  const withIds = (() => {
    if (!poll.data) return poll;
    const keys = Object.keys(poll.data).filter((k) => /^question\d+$/i.test(k)).sort((a,b)=>parseInt(a.replace(/\D/g,""),10)-parseInt(b.replace(/\D/g,""),10));
    const newData = { ...poll.data };
    keys.forEach((k) => {
      const q = { ...(newData[k] || {}) };
      if (typeof q.questionID !== "string" || !q.questionID.startsWith("qid_")) {
        q.questionID = `qid_${Date.now()}_${Math.random().toString(36).slice(2,6)}_${k}`;
      }
      newData[k] = q;
    });
    return { ...poll, data: newData };
  })();

  let toPublish;
  if (slideIdx === 0) {
    const initData = { ...withIds.data };
    Object.keys(initData).filter((k) => /^question\d+$/i.test(k)).forEach((k) => { initData[k] = { ...initData[k], isQuestionApproved: false }; });
    toPublish = { ...withIds, data: initData, isApproved: true, showresult: false, intropage: true };
  } else if (slideIdx > 0 && withIds.data && slideIdx <= Object.keys(withIds.data).filter((k) => /^question\d+$/i.test(k)).length) {
    const keys = Object.keys(withIds.data).filter((k) => /^question\d+$/i.test(k)).sort((a,b)=>parseInt(a.replace(/\D/g,""),10)-parseInt(b.replace(/\D/g,""),10));
    const newData = { ...withIds.data };
    keys.forEach((k, i) => { newData[k] = { ...newData[k], isQuestionApproved: i + 1 === slideIdx }; });
    toPublish = { ...withIds, data: newData, isApproved: true, showresult: false, intropage: false };
  } else if (slideIdx === 999) {
    toPublish = { ...withIds, isApproved: false, showresult: false, intropage: false };
  } else {
    // Result slide: no question is live any more, the quiz stays open (isApproved)
    // and the result is revealed only when the admin turns Show Result on.
    const resultData = { ...withIds.data };
    Object.keys(resultData).filter((k) => /^question\d+$/i.test(k)).forEach((k) => { resultData[k] = { ...resultData[k], isQuestionApproved: false }; });
    toPublish = { ...withIds, data: resultData, isApproved: true, showresult: opts.showresult === true, intropage: false };
  }

  import("./adminStore.js").then(({ updatePollItem, removePollItem }) => {
    if (toPublish.isApproved === false) {
      removePollItem(sessionId, String(toPublish.id));
    } else {
      updatePollItem(sessionId, toPublish);
    }
  });
}
